import i18next from 'i18next';

i18next.addResources('es_CL', 'NoRiders', {
  changeToPickup: 'Cambiar a retiro en local',
  tryLater: 'Intentarlo más tarde',
  sorry: 'Lo sentimos, pero en estos momentos estamos sin disponibilidad de repartidores.',
  continue: '¿Cómo deseas continuar?'
});
